import { GET_TIRE_BRAND_BEGIN, GET_TIRE_BRAND_SUCCESS } from "./type";

const initialState = {
    items: [],
    loading: false
}
export const TireBrandReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TIRE_BRAND_BEGIN:
            return {
                ...state,
                loading: true
            }
        case GET_TIRE_BRAND_SUCCESS:
            return action.payload
        default:
            return state
    }
};
